import Layout from '@/components/layout/Layout';
import { FC } from 'react';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import PageHeadingSort from '@/components/ui/page-heading-sort/PageHeadingSort';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import SectionTitleMenu from '@/components/ui/section-title-menu/SectionTitleMenu';
import { IPodcastPage, IPodcastData } from '@/interfaces/podcastsPage.interface';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';

export interface IPodcasts {
  books: IPodcastPage;
  sortingName: string;
  sortingUrl?: string | undefined;
}

const Podcasts: FC<IPodcasts> = ({ books, sortingName, sortingUrl }) => {
  const pagesCount = Math.ceil(books?.total_count / BOOKS_FOR_PAGE);

  //Seo block
  const SEO_TITLE = 'Слушать Подкасты онлайн бесплатно и без регистрации или скачать бесплатно в mp3';
  const SEO_DESCRIPTION = 'Бесплатно и удобно слушайте или скачивайте лучшие подкасты на сайте онлайн библиотеки Kuchaknig 📚';
  const SEO_CANONICAL = '/podcasts/';

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Breadcrumbs pageName="Подкасты" />

      <SectionTitleMenu extraClassName={'sectionTitleMenu_sort'}>
        <PageHeadingSort isPodcast titleName="Подкасты" sortingName={sortingName} url="/podcasts/" extraClassName="pageHeading_plain" />
      </SectionTitleMenu>

      <div data-cards="list" className="cardsWrapper">
        {books.data && books.data.length ? (
          books.data.map((book: IPodcastData) => <BookCardItem alias={book.alias} createdAt={book.created_at} author={'book.author'} book={book} rating={book.rating} key={book.id} draft={book.draft} isPodcast={true} />)
        ) : (
          <div>Книги не найдены</div>
        )}
      </div>
      {sortingUrl ? <Pagination pagesCount={pagesCount ?? 0} postName={`podcasts/${sortingUrl}/page=`} /> : <Pagination pagesCount={pagesCount ?? 0} postName="podcasts/page=" />}
      {/* <Breadcrumbs pageName="Подкасты" isBottom={true} /> */}
    </Layout>
  );
};

export default Podcasts;
